module.exports = __webpack_public_path__ + "static/media/teriyakivegetable.1833440b.jpg";